export function waitFactory(ms) {
  return function (value) {
    return new Promise(resolve => setTimeout(() => resolve(value), ms));
  };
}

export default function wait(ms) {
  return waitFactory(ms)();
}
